import { Component, EventEmitter } from '@angular/core';
import { AuthUserApps, AuthUserApps_Document } from '../../model/auth-user-apps';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { FilterDataService } from '../../services/filter-data.service';
import { AppService } from '../../services/app.service';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { SelectListItem } from 'projects/Shared-Lib/model/select-property';
import { Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { environment } from 'projects/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-auth-user-apps-edit',
  templateUrl: './auth-user-apps-edit.component.html',
  styleUrls: ['./auth-user-apps-edit.component.css']
})
export class AuthUserAppsEditComponent {
  ControllerName = 'AuthUserApps';
  AuthUserCompleteAPI = 'AuthUser/AuthUserAutoComplete';

  IsNew: boolean;
  UserID: string;
  Title: string;
  Doc: AuthUserApps_Document;
  SelectedAuthUser: any;
  AuthUserList: any;

  typeahead = new EventEmitter<string>();
    searching: boolean;
    searchFailed: boolean;
    searchList: AuthUserApps[] = [];
    searchList$: Observable<any[]>;
    searchListinput$ = new Subject<string>();

  constructor(private route: ActivatedRoute, private dlgService: DialogService,
                private appService: AppService, private filterService: FilterDataService,
                private router: Router, private dataService: DataService, private http: HttpClient) {

    this.Doc = new AuthUserApps_Document(dlgService, router, dataService);
    this.Doc.ApplicationID = '';
    this.Doc.SelectEnabled = 1;

    this.dataService.getData(this.ControllerName + '/init', null,
      (data) => {
        this.Doc.ddlAuthApplication = new Array<SelectListItem>();
        let i = 1;
        data.AuthApplication.forEach(it => {
          let o: SelectListItem = {
            value: it.ApplicationID,
            text: it.ApplicationID,
            index: i++
          };
          this.Doc.ddlAuthApplication.push(o);
        });
      }
    );
  }

  ngOnInit() {
    this.UserID = this.route.snapshot.paramMap.get('id');

    if (this.UserID) {
      //edit mode
      this.Doc.GetDocument(this.UserID);
      this.IsNew = false;
      this.Title = "Edit";
    }
    else {
      //create mode
      this.IsNew = true;
      this.Title = "Create";
    }
  }

  isValid(): boolean {
    if (this.Doc.UserAccount && this.Doc.UserAccount !== ''
        && this.Doc.ApplicationID && this.Doc.ApplicationID !== '') {
      return false;
    }

    return true;
  }

  Submit() {
    let postData: AuthUserApps = new AuthUserApps();
    this.Doc.IsEnabled = this.Doc.SelectEnabled === 1;
    postData.SetData(this.Doc);
    if(this.IsNew) {
      this.dataService.addData(this.ControllerName, postData, (ret) => {
          let result = this.dlgService.CreateSubmit();
          result.then((ret) => {
            if (ret === 'Back') {
              this.Cancel();
            } 
            else if(ret === 'Create Another') {
              this.Doc.UserID = '';
              this.Doc.UserAccount = '';
              this.Doc.ApplicationID = '';
              this.Doc.IsEnabled = false;
              this.Doc.SelectEnabled = 1;
              this.searchList = [];
              this.Doc.SelectedAuthUser = {};
            }
          }).catch((error) => {
            console.error(error);
          });
      }, (ret) =>{
        let result = this.dlgService.ErrorInformation(ret.Message);
        result.then((ret) => {
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  Cancel() {
    let lastPageInfo = this.filterService.GetSearchInfo();
    if (lastPageInfo.RouteName) {
      this.router.navigate([lastPageInfo.RouteName]);
    }
    else
      this.router.navigate(['/Auth/AuthUserApps']);
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => {
        this.searchList = [];
        this.searching = true;
        this.Doc.UserAccount = '';
      }),
      switchMap(term => term.trim() !== '' ?
        this.http.get(`${environment.APIBaseUrl}${this.AuthUserCompleteAPI}/${term}`).pipe(
          tap(() => {
            this.searchFailed = false;
          }),
          map((ret) => {
            this.searchList = ret["Data"];
            return ret["Data"];
          }),
          catchError(() => {
            this.searchFailed = true;
            this.searchList = [];
            this.SelectedAuthUser = {};
            this.Doc.UserAccount = '';
            return of([]);
          })) : of([])
      ),
      tap(() => this.searching = false)
  );

  formatter = (x: AuthUserApps) => x.UserAccount;

  selectedItem(item) {
    let SelectedAuthUser = item.item;
    this.Doc.UserAccount = SelectedAuthUser.UserAccount;
    this.Doc.UserID = SelectedAuthUser.UserID;
  }
}
